import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT, ENTITY_MANAGER_END_POINTS } from '../utils/environment'
import { validateApiParams } from '../utils/functions'
import {
  DataReviewState,
  EnrollmentWithCases,
  ProceedQuickDeniedCaseResult,
  PropagateEntitiesPayload,
  PropagateSharedPayload,
} from '../types/multiProductEnrollment.types'

//NEED TO REMOVE THIS FUNCTION AND USE FETCH WEB DETAILS IN ITS PLACE
export const fetchEnrollmentWithChildCases = async (
  enrollmentRecordId: number
): Promise<{ data: EnrollmentWithCases }> => {
  validateApiParams(
    { id: enrollmentRecordId },
    {
      endpoint: `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/hcp_portal_entity/${enrollmentRecordId}`,
      method: 'POST',
    }
  )

  try {
    return await axiosInstance.post(
      `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/hcp_portal_entity/${enrollmentRecordId}`,
      {
        entity_name: 'hcp_portal_entity',
        select: [
          'name',
          'enrollment_id',
          'case_id',
          'hcp_program',
          'created_at',
          'received_from',
          'enrollment_status',
          'hcp_enrollment_details',
          'has_patient_sign',
          'has_provider_sign',
          'has_dedup_resolved',
        ],
        related_entities: {
          enrollment_status: {
            select: ['value', 'label'],
          },
          hcp_program: {
            select: ['name'],
          },
          hcp_enrollment_details: {
            select: ['case_id', 'case', 'record_status', 'workflow_proceeded'],
            related_entities: {
              case: {
                select: [
                  'id',
                  'product_id',
                  'service_id',
                  'program_id',
                  'sub_service_id',
                  'patient_id',
                ],
              },
            },
          },
        },
      }
    )
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const fetchDataReviewState = async (
  enrollmentRecordId: number
): Promise<{ data: DataReviewState }> => {
  try {
    return await axiosInstance.get(
      `${API_END_POINT.ENTITY_MANAGER_V3}enrollment/${enrollmentRecordId}/data-review-state`
    )
  } catch {
    return {
      data: {
        enrollment_id: enrollmentRecordId,
        child_case_ids: [],
      },
    }
  }
}

export const saveDataReviewDraft = async (
  enrollmentRecordId: number,
  payload: Record<string, unknown>
) => {
  return axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}enrollment/${enrollmentRecordId}/data-review-draft`,
    payload
  )
}

export const propagateEntitiesToChildCases = async (
  enrollmentRecordId: number,
  payload: PropagateEntitiesPayload
) => {
  return axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}enrollment/${enrollmentRecordId}/propagate-entities`,
    payload
  )
}

export const propagateSharedInfoToChildCases = async (
  enrollmentRecordId: number,
  payload: PropagateSharedPayload
) => {
  return axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}enrollment/${enrollmentRecordId}/propagate-shared/attachments`,
    payload
  )
}

export const proceedQuickDeniedCases = async (
  recordId: string | number
): Promise<{ data: ProceedQuickDeniedCaseResult }> => {
  validateApiParams(
    { id: recordId },
    {
      endpoint: `${API_END_POINT.WORKFLOW}/${ENTITY_MANAGER_END_POINTS.CASE_MANAGEMENT}/hcp-portal-entity/${recordId}/proceed-quick-denied-cases`,
      method: 'POST',
    }
  )

  return axiosInstance.post(
    `${API_END_POINT.WORKFLOW}/${ENTITY_MANAGER_END_POINTS.CASE_MANAGEMENT}/hcp-portal-entity/${recordId}/proceed-quick-denied-cases`
  )
}
